import qaConfig from './qa'
import prodConfig from './prod'
import devConfig from './dev'

const prodDomains = [
    'https://webview.waterguru.com',
    'https://webview.waterguru-prod.com'
]

const MODE = (~prodDomains.indexOf(location.origin) && process.env.NODE_ENV === 'production') ? 'prod' : 'qa'
const CONFIG = (process.env.NODE_ENV === 'production') ? ((MODE === 'prod') ? prodConfig : qaConfig) : devConfig

export default CONFIG
